'use client';
import { useRouter, usePathname } from '@/i18n/routing';
// import { trackEvent } from '@/lib/amplitude';
// import { AmplitudeEvents } from '@/lib/amplitude/events';
import { ChevronLeft, ChevronRight, EarthIcon } from 'lucide-react';
import { useLocale } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import React, { useTransition } from 'react';

const ChangeLang = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams.toString());

  const [isPending, startTransition] = useTransition();

  const changeLang = (lang: 'ar' | 'en' | undefined) => {
    startTransition(() => {
      const newPathname = params.toString() ? `${pathname}?${params.toString()}` : pathname;
      if (lang === 'ar' || lang === 'en') {
        router.replace(newPathname, { locale: lang });
        // trackEvent(AmplitudeEvents.CHANGE_LANGUAGE_CLICKED);
      }
    });
  };

  const currentLocale = useLocale();
  const targetLang: 'ar' | 'en' = currentLocale === 'en' ? 'ar' : 'en';
  const buttonText = currentLocale === 'en' ? 'عربي' : 'ENG';

  return (
    <div
      onClick={() => changeLang(targetLang)}
      style={{ opacity: isPending ? 0.5 : 1 }}
      className="text-primary mt-1 cursor-pointer text-sm font-extrabold transition-opacity hover:opacity-50"
    >
      {buttonText}
    </div>
  );
};

const ChangeMobileLang = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams.toString());

  const [isPending, startTransition] = useTransition();

  const changeLang = (lang: 'ar' | 'en' | undefined) => {
    startTransition(() => {
      const newPathname = params.toString() ? `${pathname}?${params.toString()}` : pathname;
      if (lang === 'ar' || lang === 'en') {
        router.replace(newPathname, { locale: lang });
        // trackEvent(AmplitudeEvents.CHANGE_LANGUAGE_CLICKED);
      }
    });
  };

  const currentLocale = useLocale();
  const targetLang: 'ar' | 'en' = currentLocale === 'en' ? 'ar' : 'en';
  const buttonText = currentLocale === 'en' ? 'تغيير اللغة ' : 'Change Language';

  return (
    <div
      onClick={() => {
        changeLang(targetLang);
      }}
      style={{ opacity: isPending ? 0.5 : 1 }}
      className="cursor-pointer space-y-5 rounded-lg border border-[#ECE9FF] px-3 py-4"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 pb-2">
          <span>
            <EarthIcon />
          </span>
          {buttonText}
        </div>
        <span>{currentLocale === 'en' ? <ChevronRight /> : <ChevronLeft />}</span>
      </div>
    </div>
  );
};

export { ChangeLang, ChangeMobileLang };
